import apiClient from './api/client'
import type {
  Payment,
  CheckoutSession,
  ConnectionPaymentRequest,
  EarningsSummary,
  ExpertService,
  WithdrawalRequest,
  SeekerTransactionSummary,
} from '../types/payment'
import type { PaginatedResponse } from '../types'

export const paymentService = {
  // Get payment history
  async getPayments(): Promise<PaginatedResponse<Payment>> {
    const { data } = await apiClient.get('/payments/history/')
    return data
  },

  // Get a single payment
  async getPayment(id: string): Promise<Payment> {
    const { data } = await apiClient.get(`/payments/history/${id}/`)
    return data
  },

  // Create checkout session for connection payment
  async createConnectionCheckout(request: ConnectionPaymentRequest): Promise<CheckoutSession> {
    const { data } = await apiClient.post('/payments/connection/', request)
    return data
  },

  // ===============================
  // Expert Earnings Endpoints
  // ===============================

  // Get earnings summary for expert
  async getEarningsSummary(): Promise<EarningsSummary> {
    const { data } = await apiClient.get('/payments/earnings/')
    return data
  },

  // Get list of services with earnings
  async getExpertServices(): Promise<ExpertService[]> {
    const { data } = await apiClient.get('/payments/earnings/services/')
    return data
  },

  // Get withdrawal history
  async getWithdrawals(): Promise<PaginatedResponse<WithdrawalRequest>> {
    const { data } = await apiClient.get('/payments/withdrawals/')
    return data
  },

  // Create a withdrawal request
  async createWithdrawal(
    amount_cents: number,
    payment_details?: string
  ): Promise<WithdrawalRequest> {
    const { data } = await apiClient.post('/payments/withdrawals/', {
      amount_cents,
      payment_details: payment_details || '',
    })
    return data
  },

  // ===============================
  // Seeker Transaction Endpoints
  // ===============================

  // Get transaction summary for seeker
  async getSeekerTransactions(): Promise<SeekerTransactionSummary> {
    const { data } = await apiClient.get('/payments/transactions/')
    return data
  },
}

export default paymentService
